module.exports = __webpack_public_path__ + "img/coliflor.c89f05ca.svg";